:host {
  font-family: var(--font-family-sans);
  font-weight: var(--font-rg);
}

:host > div {
  display: flex;
  width: inherit;
  padding: calc(var(--space-unit) * 2);
  background: var(--color-primary03);
  border-radius: var(--border-radius);
}

:host > div > slot {
  color: var(--color-default-text);
  font-size: 14px;
}

:host > div > z-icon {
  margin-left: calc(var(--space-unit) * 2);
  cursor: pointer;
  fill: var(--color-primary01);
}
